import * as React from "react"
import {graphql} from "gatsby"
import {Link} from "gatsby"
import Footer from "../components/footer";

const IndexPage = ({data}) => {
  return (
    <>
      <main>
        <title>Hvordan tjene penger på nett? | Tjene-penger.com</title>

          <h1>Tjene penger online</h1>
          <p>Her følger en oversikt over hvordan du kan tjene penger online:</p>
          <ul>
              {data.allSanityArticle.edges.map(({node},i) => {
                  return(
                      <li key={i}><Link to={'/'+node.slug.current}>{node.title}</Link></li>
                  )
              })}
          </ul>
      </main>
      <Footer/>
    </>
  )
}

export default IndexPage


export const query = graphql`
query BankQuery {
      allSanityArticle(filter: {slug: {current: {ne: null}}, channel: {slug: {current: {eq: "tjenepenger"}}}}, sort: {order: ASC, fields: priority}) {
        edges {
          node{
            slug{
                current
            }
            title
            intro
            image {
              asset {
                url
              }
            }
          }
        }
      }
    }
`